import { render } from "./paquetes.vue?vue&type=template&id=588af898&scoped=true"
import script from "./paquetes.vue?vue&type=script&lang=js"
export * from "./paquetes.vue?vue&type=script&lang=js"

import "./paquetes.vue?vue&type=style&index=0&id=588af898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588af898"]])

export default __exports__